import { mergeAll } from '../operators/mergeAll';
import { internalFromArray } from './fromArray';
import { argsOrArgArray } from '../util/argsOrArgArray';
import { innerFrom } from './from';
import { EMPTY } from './empty';
import { popNumber, popScheduler } from '../util/args';
export function merge(...args) {
    const scheduler = popScheduler(args);
    const concurrent = popNumber(args, Infinity);
    args = argsOrArgArray(args);
    return !args.length
        ?
            EMPTY
        : args.length === 1
            ?
                innerFrom(args[0])
            :
                mergeAll(concurrent)(internalFromArray(args, scheduler));
}
//# sourceMappingURL=merge.js.map